import { render, staticRenderFns } from "./AssumeRoleMenu.vue?vue&type=template&id=8ea519dc"
import script from "./AssumeRoleMenu.vue?vue&type=script&lang=ts"
export * from "./AssumeRoleMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports